var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66732 4.00391H12.6673C13.4007 4.00391 14.0007 4.60391 14.0007 5.33724V26.6706C14.0007 27.404 13.4007 28.004 12.6673 28.004H8.66732C7.93398 28.004 7.33398 27.404 7.33398 26.6706V5.33724C7.33398 4.60391 7.93398 4.00391 8.66732 4.00391ZM19.334 4.00391H23.334C24.0673 4.00391 24.6673 4.60391 24.6673 5.33724V26.6706C24.6673 27.404 24.0673 28.004 23.334 28.004H19.334C18.6007 28.004 18.0007 27.404 18.0007 26.6706V5.33724C18.0007 4.60391 18.6007 4.00391 19.334 4.00391Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.a5f5d52a37aed1e4d4f7660a76614685.svg";
export { ForwardRef as ReactComponent };